import { useMutation } from '@/core/hooks/use-mutation'
import { UserDetailsModel } from '@/features/auth/types/models/user-details.model'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { updateProfile } from '../../providers/client'
import { updateProfileSchema } from '../../types/dtos/update-profile.dto'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'
import { useAuth } from '@/core/store/auth'

export const useUpdateProfile = ({
  onSuccess,
  user,
}: {
  onSuccess: () => void
  user: UserDetailsModel | null
}) => {
  const { setUser } = useAuth()

  const form = useForm({
    defaultValues: {
      email: user?.email ?? '',
      birthdate: user?.birthdate ?? '',
      username: user?.username ?? '',
      image: null,
    },
    resolver: zodResolver(updateProfileSchema),
  })
  const router = useRouter()
  const { isPending, mutate } = useMutation({
    mutation: updateProfile,
    onSuccess(data) {
      router.refresh()
      setUser(data)

      onSuccess()
    },
    onError(error) {
      form.setError('username', { message: error })
    },
  })
  useEffect(() => {
    if (user) {
      form.reset({
        email: user.email ?? '',
        birthdate: user.birthdate ?? '',
        username: user.username ?? '',
        image: null,
      })
    }
  }, [user, form])

  const handleSubmit = form.handleSubmit(data => {
    mutate(data)
  })

  return { form, handleSubmit, isPending }
}
